export var EventTypes;
(function (EventTypes) {
    EventTypes["DownloadSiteReport"] = "DownloadSiteReport";
    EventTypes["DownloadSiteDocs"] = "DownloadSiteDocs";
    EventTypes["CopySiteLink"] = "CopySiteLink";
})(EventTypes || (EventTypes = {}));
